export const BUTTON_VARIANTS = ["primary", "secondary", "tertiary"] as const;
export const BUTTON_SIZES = ["small", "medium"] as const;
export const BUTTON_ICON_POSITIONS = ["start", "end"] as const;

// Button and IconButton may not necessarily have the same variants, sizes, and shapes
// For now, we are re-using the same constants, but in case of divergence, we should
// use different constants for IconButton
export const ICON_BUTTON_VARIANTS = BUTTON_VARIANTS;
export const ICON_BUTTON_SIZES = BUTTON_SIZES;
export const ICON_BUTTON_SHAPES = ["circle", "square"] as const;

const BUTTON_VAR_SIZE_SMALL = "var(--fs-btn-size-small)";
const BUTTON_VAR_SIZE_MEDIUM = "var(--fs-btn-size-medium)";

export const BUTTON_VAR_SIZE_MAP: Record<
  (typeof BUTTON_SIZES)[number],
  string
> = {
  small: BUTTON_VAR_SIZE_SMALL,
  medium: BUTTON_VAR_SIZE_MEDIUM,
};

export const ICON_BUTTON_VAR_SIZE_MAP: Record<
  (typeof ICON_BUTTON_SIZES)[number],
  string
> = {
  small: BUTTON_VAR_SIZE_SMALL,
  medium: BUTTON_VAR_SIZE_MEDIUM,
};
